import { render, staticRenderFns } from "./SignSimple.vue?vue&type=template&id=48ba00d6&scoped=true"
import script from "./SignSimple.vue?vue&type=script&lang=js"
export * from "./SignSimple.vue?vue&type=script&lang=js"
import style0 from "./SignSimple.vue?vue&type=style&index=0&id=48ba00d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba00d6",
  null
  
)

export default component.exports